import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import store from "./store";
import GlobalStyles from "./styles/GlobalStyles";
import { ToastProvider } from "./components/Toast";
import { CurrencyProvider } from "./context/CurrencyContext";
import { AccentProvider } from "./context/AccentContext";
import { PageThemeProvider } from "./context/PageThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import AccentThemeProvider from "./components/AccentThemeProvider";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AccentProvider>
      <PageThemeProvider>
        <AccentThemeProvider>
          <HelmetProvider>
            <GlobalStyles />
            <CurrencyProvider>
              <LanguageProvider>
                <ToastProvider>
                  <App />
                </ToastProvider>
              </LanguageProvider>
            </CurrencyProvider>
          </HelmetProvider>
        </AccentThemeProvider>
      </PageThemeProvider>
    </AccentProvider>
  </Provider>,
);

serviceWorkerRegistration.register();
